import getApiInstance from 'data/common/ApiCallGenerique';
import { Logger } from 'data/common';
import api from './api';

const apiCaller = getApiInstance();

export function getUsers(env) {
    return dispatch => {
        return apiCaller
            .call(api.getAllUsers(env))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: `${env.toUpperCase()}__SET_USERS`,
                        users: data.users
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setUsers - ', error);
                throw error;
            });
    };
}



// WEBPACK FOOTER //
// ./environments/genericEnv/data/Users/actions.js